import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df658c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document-icon" }
const _hoisted_2 = {
  key: 0,
  width: "200px",
  size: "40"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "67",
  height: "81",
  viewbox: "0 0 67 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M 66.311 18.176 L 48.248 0.389 C 48.005 0.146 47.665 0 47.308 0 L 13.985 0 C 8.946 0 4.864 4.309 4.864 9.623 L 4.864 45.133 L 0.425 45.133 L 0.425 69.206 L 4.864 69.206 L 4.864 71.377 C 4.864 76.675 8.963 81 13.985 81 L 57.628 81 C 62.666 81 66.748 76.691 66.748 71.377 L 66.748 19.229 C 66.748 18.841 66.602 18.452 66.311 18.176 Z M 46.855 2.981 L 62.569 18.468 L 54.015 18.468 C 50.062 18.468 46.855 15.309 46.855 11.437 L 46.855 2.981 Z M 63.994 71.377 C 63.994 75.087 61.143 78.1 57.628 78.1 L 13.985 78.1 C 10.469 78.1 7.618 75.087 7.618 71.377 L 7.618 69.206 L 37.912 69.206 C 43.825 69.206 48.604 63.812 48.604 57.17 C 48.604 50.528 43.809 45.133 37.912 45.133 L 7.618 45.133 L 7.618 9.623 C 7.618 5.913 10.469 2.9 13.985 2.9 L 44.101 2.9 L 44.101 11.437 C 44.101 16.913 48.539 21.368 54.015 21.368 L 63.994 21.368 L 63.994 71.377 Z",
    fill: "#2650A0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.2971 56.4084C15.6697 56.0034 15.8641 55.5012 15.8641 54.8856C15.8641 54.27 15.6697 53.7516 15.2971 53.3466C14.9245 52.9416 14.3575 52.731 13.5961 52.731H10.9717V57.024H13.5961C14.3575 57.0078 14.9083 56.8134 15.2971 56.4084Z",
    fill: "#2650A0"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mimeTypeSlag)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.mimeTypeSlag), 1))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}